import { NavLink, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { Tooltip, TooltipAnchor } from '@/shared/components/Tooltip'
import { useSidebar } from '@/context/SidebarContext'
import { styles } from '@/shell/layout.styles'
import { NAV_ICONS, type NavItem } from '@/shell/nav/navIcons'

export function SidebarNavItem({ item }: { item: NavItem }) {
  const { pathname } = useLocation()
  const { collapsed } = useSidebar()
  const [hovered, setHovered] = useState(false)
  const renderLink = (describedBy?: string) => (
    <NavLink
      to={item.to}
      end={item.end}
      aria-describedby={describedBy}
      aria-label={collapsed ? item.label : undefined}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={({ isActive }) => {
        const active = isActive || (item.matchPrefix ? pathname.startsWith(item.matchPrefix) : false)
        return { ...styles.navItem, ...(collapsed ? styles.navItemCollapsed : {}), ...(active ? styles.navItemActive : hovered ? styles.navItemHover : {}) }
      }}
    >
      {NAV_ICONS[item.icon]}
      {!collapsed && item.label}
    </NavLink>
  )
  // Tooltip stays on in both states - it's the only label when collapsed.
  return item.tooltip
    ? (
        <Tooltip text={item.tooltip} placement="right">
          <TooltipAnchor>{(describedBy) => renderLink(describedBy)}</TooltipAnchor>
        </Tooltip>
      )
    : renderLink()
}

